
// region JS Imports

// region External Modules
import $ from "jquery"
import u from "umbrellajs"
// endregion External Modules

// Private Modules
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import GoogleStreetView from "./google_street_view"
import StaticMap from "./static_map"
// endregion Private Components

// endregion JS Imports


const CELL_CLASS_NAME = "cell--coliving-spaces--pictures-and-map-browser--toggle"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`

const init = () => {
  u(`.${CELL_CLASS_NAME}`).each((el) => {
    const $el = $(el)
    if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_INITIALIZED_CLASS_NAME)

    StaticMap.init({
      main: $el,
    })

    GoogleStreetView.init({
      main: $el,
    })
  })
}


export {
  init,
}
